import React from 'react';
import DescriptionIcon from '@material-ui/icons/Description';

const ReportTempateIcon = () => (<DescriptionIcon/>);

export default ReportTempateIcon;

